import React, { useEffect, useState } from "react";
import { formatIDR } from "../../utils/helpers/formatIDR";
import VariantAvailabilityDrawer from "./components/VariantAvailabilityDrawer";

const inventoryLabel = (variant) => {
  if (variant?.inventory_mode === "non_stock" || variant?.is_unlimited) return "Selalu tersedia";
  if (variant?.inventory_mode === "made_to_order") {
    return Number.isFinite(variant?.remaining_stock)
      ? `Bisa dibuat ${variant?.remaining_stock || 0}`
      : "Siap dibuat";
  }
  return `Stok ${variant?.remaining_stock || 0} ${variant?.unit || "pcs"}`;
};

const VariantSelectionModal = ({ group, onClose, onSelect }) => {
  const [unavailableVariant, setUnavailableVariant] = useState(null);

  useEffect(() => {
    setUnavailableVariant(null);
  }, [group]);

  if (!group) return null;

  return (
    <div
      className="modal modal-blur show d-block pos-variant-modal"
      tabIndex="-1"
      role="dialog"
      aria-modal="true"
      aria-labelledby="pos-variant-title"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.3)", zIndex: 1090 }}>
      <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable" role="document">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <div>
              <div className="text-primary text-uppercase fw-bold fs-6 mb-1">Pilih varian</div>
              <h5 className="modal-title" id="pos-variant-title">
                {group?.name}
              </h5>
              <p className="text-secondary mb-0">
                Pilih {group?.option_name?.toLowerCase() || "varian"} yang akan dimasukkan ke keranjang.
              </p>
            </div>
            <button type="button" className="btn-close" aria-label="Tutup" onClick={onClose} />
          </div>
          <div className="modal-body">
            <div className="row g-3">
              {(group?.variants || []).map((variant) => {
                const isAvailable = variant?.can_sell !== false && variant?.remaining_stock > 0;
                const unavailableLabel =
                  variant?.inventory_mode === "made_to_order"
                    ? (variant?.materials || []).length
                      ? "Bahan tidak cukup"
                      : "Resep belum diatur"
                    : "Tidak tersedia";
                return (
                  <div className="col-md-6" key={variant.id}>
                    <button
                      type="button"
                      className={`card w-100 h-100 text-start pos-variant-option ${
                        isAvailable ? "border-primary" : "opacity-50"
                      }`}
                      aria-disabled={!isAvailable}
                      onClick={(event) => {
                        if (isAvailable) {
                          onSelect(variant, event.currentTarget);
                          return;
                        }

                        setUnavailableVariant(variant);
                      }}>
                      <div className="card-body">
                        <div className="d-flex align-items-start justify-content-between gap-3 mb-3">
                          <div>
                            <div className="h3 mb-1">{variant?.variant_label || "Reguler"}</div>
                            {variant?.sku ? <span className="badge bg-secondary-lt">{variant.sku}</span> : null}
                          </div>
                          <span className={`badge ${isAvailable ? "bg-success-lt text-success" : "bg-danger-lt text-danger"}`}>
                            {isAvailable ? inventoryLabel(variant) : unavailableLabel}
                          </span>
                        </div>
                        <div className="d-flex align-items-end justify-content-between gap-3">
                          <div>
                            <div className="text-secondary fs-6">Harga jual</div>
                            <div className="h2 text-primary mb-0">{formatIDR(variant?.unit_price || 0)}</div>
                          </div>
                          <span className={`btn btn-sm ${isAvailable ? "btn-primary" : "bg-secondary-lt text-secondary"}`}>
                            {isAvailable ? "Pilih" : "Lihat penyebab"}
                          </span>
                        </div>
                      </div>
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-link link-secondary" onClick={onClose}>
              Batal
            </button>
          </div>
          <VariantAvailabilityDrawer variant={unavailableVariant} onClose={() => setUnavailableVariant(null)} />
        </div>
      </div>
    </div>
  );
};

export default VariantSelectionModal;
